import { render, staticRenderFns } from "./dropdownSelector.vue?vue&type=template&id=1365a194&scoped=true"
import script from "./dropdownSelector.vue?vue&type=script&lang=js"
export * from "./dropdownSelector.vue?vue&type=script&lang=js"
import style0 from "./dropdownSelector.vue?vue&type=style&index=0&id=1365a194&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1365a194",
  null
  
)

export default component.exports